module.exports = __webpack_public_path__ + "img/开门按钮 (13).fc931847.jpg";